export default __webpack_public_path__ + "static/media/hr.7ad54390.jpg";